import React from 'react';

const JoinOurWelcomingCommunitySection = () => {
    return (
        <p>
            WNB.rb was founded in early 2021. It has grown to over 500 Rubyists, connecting at
            virtual and in-person events around the globe. Find out more about{' '}
            <a href="/community" className="whitespace-nowrap font-medium">
                our community
            </a>
            .
        </p>
    );
};

export default JoinOurWelcomingCommunitySection;
